export default {
  locale: localStorage.getItem('locale') || (navigator.language || navigator.userLanguage).split('-')[0] || 'en',

  id: '',
  email: 'Email',
  avatar: '',
  lastname: 'Фамилия',
  firstname: 'Имя',
  confirmed: true,
  priest: false,
  parish: false,
  parishioner: false,
  balance: [],
  profile: {
    country: '',
    region: '',
    city: '',
    birthdate: null,
    sex: '',
    skype: '',
    about: ''
  },

  countries: {}
}
